import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { cn } from '~/helpers/utils';

type AgeFieldProps = {
  name: string;
  label?: string;
  labelClass?: string;
  placeholder?: string;
};

const AgeField: React.FC<AgeFieldProps> = ({
  name,
  label,
  labelClass,
  placeholder,
}) => {
  const { control } = useFormContext();

  const inputId: string = `field-${name}`;
  
  return (
    <div className="form-control">
      {label && (
        <label htmlFor={inputId} className={cn('form-label', labelClass)}>
          {label}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render= {({ field, fieldState }) => (
          <>
            <input
              {...field}
              id={inputId}
              type="number"
              placeholder={placeholder}
              className={cn(
                'form-input !py-4 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
                fieldState.error && 'form-input--error',
              )}
              onChange={(e) => {
                const { value } = e.target;
                field.onChange(value === '' ? undefined : Number(value));
              }}
              value={field.value ?? ''}
            />
            {fieldState.error && (
              <span className="text-sm text-tomato-600">{fieldState.error.message}</span>
            )}
          </>
        )}
      />
    </div>
  );
};

export default AgeField;